const PetitionError = require('../../petitionError');
const { getAnonymous } = require('../../httpRequester');

class ThermokingException extends PetitionError {
  constructor(code) {
    super('Thermoking error', code);
  }
}

const getTkToken = async (thermokingUserName, thermokingPassword, thermokingExternalId) => {
  try {
    const response = await getAnonymous(
      `api/tk_token?userName=${thermokingUserName}&password=${thermokingPassword}&externalId=${thermokingExternalId}`,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

const getActiveDevicesB = async (tkToken, externalId) => {
  try {
    const response = await getAnonymous(`api/tk_active_devices?tokenTK=${tkToken}&externalId=${externalId}`);
    if (response.result === ThermokingException.success) {
      return response;
    }
    throw new ThermokingException(response.result);
  } catch (error) {
    console.error(error);
  }
};

const getTemperatureForDevice = async (device_sn) => {
  try {
    const response = await getAnonymous(`api/tk_temperature_for_device?device_sn=${device_sn}`);
    if (response.result === ThermokingException.success) {
      return response;
    }
    throw new ThermokingException(response.result);
  } catch (error) {
    console.error(error);
  }
};

module.exports = { getTkToken, getActiveDevicesB, getTemperatureForDevice };
